import { render, staticRenderFns } from "./ProductBaseAttrImport.vue?vue&type=template&id=fbbfb53a&scoped=true&"
import script from "./ProductBaseAttrImport.vue?vue&type=script&lang=js&"
export * from "./ProductBaseAttrImport.vue?vue&type=script&lang=js&"
import style0 from "./ProductBaseAttrImport.vue?vue&type=style&index=0&id=fbbfb53a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbfb53a",
  null
  
)

export default component.exports